import preact, { Component, h } from 'preact'
// @ts-ignore
import Downshift from 'downshift/preact'
import Icon from '../assets'

export type ProductAreaType = {
  id: string,
  name: string
}

interface Props {
  allProductAreas: Array<ProductAreaType>,
  selectedProductAreas: Array<ProductAreaType>,
  onUpdate: (selectedItems: Array<ProductAreaType>) => void
}

interface State {
  showList: boolean,
  selectedProductAreas: Array<ProductAreaType>,
  unSelectedProductAreas: Array<ProductAreaType>
}

export default class ProductAreaSelect extends Component<Props, State> {
  private inputRef: preact.RefObject = preact.createRef()
  private previousInput: string = ''
  constructor (props: Props) {
    super(props)
    this.state = {
      showList: false,
      selectedProductAreas: props.selectedProductAreas,
      unSelectedProductAreas: props.allProductAreas
    }

    this.removeSelectedItem = this.removeSelectedItem.bind(this)
    this.addNewItemToSelectedList = this.addNewItemToSelectedList.bind(this)
    this.setUnselectedItems = this.setUnselectedItems.bind(this)
    this.setUnselectedItems()
  }

  setUnselectedItems () {
    const newData = this.props.allProductAreas.filter(
      pa => this.state.selectedProductAreas.every(spa => spa.name !== pa.name))

    this.setState({ unSelectedProductAreas: newData }, () => this.props.onUpdate(this.state.selectedProductAreas))
  }

  addNewItemToSelectedList (item: ProductAreaType) {
    this.state.selectedProductAreas.push(item)

    this.setState({ selectedProductAreas: this.state.selectedProductAreas }, this.setUnselectedItems)
  }

  removeSelectedItem (idx: number) {
    this.state.selectedProductAreas.splice(idx, 1)
    this.setState({ selectedProductAreas: this.state.selectedProductAreas }, this.setUnselectedItems)
  }

  maybeRemoveLastSelectedITem (e: KeyboardEvent) {
    if (e.code !== 'Backspace' || !this.state.selectedProductAreas.length || this.inputRef.value !== '' || this.previousInput !== '') {
      return
    }
    this.state.selectedProductAreas.pop()
    this.setState({ selectedProductAreas: this.state.selectedProductAreas }, this.setUnselectedItems)
  }

  componentDidUpdate(previousProps: Readonly<Props>): void {
    if (previousProps.selectedProductAreas !== this.props.selectedProductAreas) {
      this.setState({ selectedProductAreas: this.props.selectedProductAreas }, this.setUnselectedItems)
    }
  }

  render ({ allProductAreas }: Props, { selectedProductAreas, unSelectedProductAreas, showList }: State) {
    const items = unSelectedProductAreas
    return (
      <div className='product-area-selectize-wrapper'>
        {
          selectedProductAreas.length ? (selectedProductAreas.map((selected, idx) => {
            return (
              <div className='product-area_selected-item' onClick={() => this.removeSelectedItem(idx)}>
                <div className='product-area_selected-item-name'>{selected.name}</div>
                <div
                  className='product-area_selected-remove-button'
                >
                  <Icon icon='close' width={12} height={12} color={'currentColor'} />
                </div>
              </div>
            )
          })) : null
        }
        <Downshift
          onChange={(selection: ProductAreaType) => this.addNewItemToSelectedList(selection)}
          itemToString={(item: ProductAreaType) => (item ? item.name : '')}
          selectedItem={null}
          stateReducer={(state: {}, changes: { type: Downshift.stateChangeTypes.clickItem }) => {
            switch (changes.type) {
              case Downshift.stateChangeTypes.clickItem:
                return {
                  ...changes,
                  inputValue: ''
                }
              default:
                return changes
            }
          }}
        >
          {({
            getInputProps,
            getItemProps,
            getLabelProps,
            getMenuProps,
            isOpen,
            inputValue,
            highlightedIndex
          }: Downshift) => {
            const suggestions = items.filter(item => !inputValue || item.name.toLowerCase().includes(inputValue.toLowerCase()))
            return (
              <div>
                <div className='product-area-selectize'>
                  <input
                    ref={r => { this.inputRef = r }}
                    className='product-area-selectize-input'
                    {...getInputProps()}
                    onFocus={() => this.setState({ showList: true })}
                    onBlur={() => this.setState({ showList: false })}
                    onKeyUp={(e) => this.maybeRemoveLastSelectedITem(e)}
                    onKeyDown={(e) => { this.previousInput = this.inputRef.value; getInputProps().onKeyDown(e) } }
                    placeholder={!selectedProductAreas.length ? 'Add product areas' : ''}
                  />
                </div>
                <ul className={`product-area-selectize-list ${!showList ? 'is-hidden' : ''}`} {...getMenuProps()}>
                  {isOpen || showList
                    ? suggestions
                      .map((item, index) => (
                        <li className='product-area-list-item'
                            {...getItemProps({
                              key: item.name,
                              index,
                              item,
                              style: {
                                backgroundColor:
                                  highlightedIndex === index ? '#2aaae1' : 'white',
                                color:
                                  highlightedIndex === index ? 'white' : '#333'
                              }
                            })}
                        >
                          {item.name}
                        </li>
                      ))
                    : null}
                  {
                    !suggestions.length && inputValue ? (
                      <li className='product-area_not-found'>{`No result found for: ${inputValue}`}</li>
                    ) : null
                  }
                </ul>
              </div>
            )
          }}
        </Downshift>
      </div>
    )
  }
}
